import dashboardService from '../../../services/dashboard-service'

export const GET_ESTADISTICAS = 'GET_ESTADISTICAS_DASHBOARD'
export const GET_ESTADISTICAS_SUCCESS = 'GET_ESTADISTICAS_DASHBOARD_SUCCESS'
export const GET_ESTADISTICAS_ERROR = 'GET_ESTADISTICAS_DASHBOARD_ERROR'
export const SET_PERIODO_ESTADISTICAS = 'SET_PERIODO_ESTADISTICAS_DASHBOARD'

export enum PeriodosEstadisticas {
  '1m' = '1m',
  '6m' = '6m',
  '1y' = '1y',
}

type ValorPorPeriodos<T> = {
  [key in PeriodosEstadisticas]: T
}

export interface Estadisticas {
  fechaActualizacion: string
  avisosActivos: number
  cvsAvisosActivos: number
  cvsAdquiridos: ValorPorPeriodos<number>
  avisosPublicados: ValorPorPeriodos<number>
}

export interface EstadisticasState {
  estadisticas: Estadisticas | null
  periodo: PeriodosEstadisticas
  loading: boolean
  error: boolean
}

const storedFilter = dashboardService.getStoredStatisticsPeriod()
const periodoInicial = storedFilter || PeriodosEstadisticas['1y']

export const initialState: EstadisticasState = {
  estadisticas: null,
  periodo: periodoInicial,
  loading: true,
  error: false,
}

export interface GetEstadisticas {
  type: typeof GET_ESTADISTICAS
  payload: null
}

export interface GetEstadisticasSuccess {
  type: typeof GET_ESTADISTICAS_SUCCESS
  payload: Estadisticas
}

export interface GetEstadisticasError {
  type: typeof GET_ESTADISTICAS_ERROR
  payload: boolean
}

export interface SetPeriodoEstadisticas {
  type: typeof SET_PERIODO_ESTADISTICAS
  payload: PeriodosEstadisticas
}

export type EstadisticasActions =
  | GetEstadisticas
  | GetEstadisticasSuccess
  | GetEstadisticasError
  | SetPeriodoEstadisticas
